import { print } from "graphql";
import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { Pagination } from './pagination';
import { Perfil, PagePerfilInput } from '@/models/perfil';

export class PerfilAPI extends BaseAPI<Perfil> {
  constructor() {
    super();
    this.backUrl = `${this.backUrl}/profiles`;
    this.apiUrl = `${this.apiUrl}/api_dash/v1/profiles`;
  }

  public list(params: any): AxiosObservable<Perfil[]> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) })
  }

  public show(id: number): AxiosObservable<Perfil> {
    return this.axios.get(`${this.apiUrl}/${id}`)
  }

  public create(body: any): AxiosObservable<Perfil> {
    return this.axios.post(`${this.apiUrl}`, body);
  }

  public update(id: number, body: any): AxiosObservable<Perfil> {
    return this.axios.patch(`${this.apiUrl}/${id}`, body)
  }

  public addFunctionality(profileId: number, body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/${profileId}/functionalities`, body);
  }

  public listFunctionalities(profileId: number, params: any): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/${profileId}/functionalities`, { params });
  }

  public removeFunctionality(profileId: number, functionalityId: number): AxiosObservable<any> {
    return this.axios.delete(`${this.apiUrl}/${profileId}/functionalities/${functionalityId}`);
  }
}
